import { render, staticRenderFns } from "./ServiceOrdersTab.vue?vue&type=template&id=6f71ed34&scoped=true"
import script from "./ServiceOrdersTab.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersTab.vue?vue&type=script&lang=js"
import style0 from "./ServiceOrdersTab.vue?vue&type=style&index=0&id=6f71ed34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f71ed34",
  null
  
)

export default component.exports